export default __webpack_public_path__ + "media/images/features/ambassador/profiles/tessei_san-c1c7baee65bd0118bdc7ee973f415f3f.jpg";